import actionCreatorFactory from "../util/redux/action-factory";
import { ReduxDispatch, ReduxState } from "./reducers";
import * as request from "../util/request";
import { env } from "../util/env";
import { showSnackbar } from "./snackbar";
import logger from "../util/logger";
import { reducerWithInitialState } from "../util/redux/typed-reducers";
import { AttachmentDto } from "../util/DTOs/AttachmentDtos";

const actionFactory = actionCreatorFactory("HypoMobiili/Attachments");

const getAttachmentByIdAction = actionFactory<{}, AttachmentDto, string>(
    "GET_ATTACHMENT"
);
export class AttachmentState {
    loading: boolean;
}

const initialAttachmentState: AttachmentState = {
    loading: false,
};

export function getAttachmentById(id: number) {
    return async (dispatch: ReduxDispatch) => {
        try {
            dispatch(getAttachmentByIdAction({}));

            const result = await request.get<AttachmentDto>(
                `${env.APP_API_HOST}/api/portaali/attachments/${id}`
            );

            dispatch(getAttachmentByIdAction.done(result));
            return result;
        } catch (error) {
            dispatch(
                getAttachmentByIdAction.failed("Error fetching attachment")
            );
            dispatch(showSnackbar("Liitteen lataus epäonnistui"));
            logger.error(error);
            throw error;
        }
    };
}

export const AttachmentsReducer = reducerWithInitialState(
    initialAttachmentState
)
    .case(getAttachmentByIdAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getAttachmentByIdAction.done, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    })
    .case(getAttachmentByIdAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    });
export default AttachmentsReducer;

export const attachmentLoading = (state: ReduxState) => {
    return state.attachments.loading;
};



// WEBPACK FOOTER //
// ./src/ducks/attachments.ts